import './scripts/fantissima-section-visibility.js'
import { initToggleContent } from './scripts/toggle-content'
import { fantissimaLegendVisibility } from './scripts/fantissima-legend-visibility.js'
import { initAddToCartSuccessModalFocus, initCalendarEvents } from './scripts/calendar.js'
import './scripts/fantissima-calendar'

initCalendarEvents()
initAddToCartSuccessModalFocus()
initToggleContent()
fantissimaLegendVisibility()
